import React, { Fragment, useContext as UseContext, useEffect as UseEffect, useState as UseState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Grid,
  Container,
  Input,
  InputLabel,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
  Button,    
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core';

import DialogContentText from '@material-ui/core/DialogContentText';

import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import LockTwoToneIcon from '@material-ui/icons/LockTwoTone';
import imgLogo from "../../../assets/images/iunir_logo_circle.png"

import usuariosService from "../../../services/usuarios.service";
import alumnosService from "../../../services/alumnos.service";
import inscripcionesService from "../../../services/inscripciones.service";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory  } from "react-router-dom";

import { AuthContext } from "../../Authentication/AuthComponent";
import Cookies from 'universal-cookie';

const LoginComponent = () => {
  const context = UseContext(AuthContext);
  const [checked1, setChecked1] = React.useState(true);
  const [stLogin, setStLogin] = React.useState(false);  

  const handleChange1 = event => {
    setChecked1(event.target.checked);
  };


  const history = useHistory();
  UseEffect(() => {    
    if (stLogin){     
      alumnosService.EsAlumno().then(verifica => {
        if(verifica.data.message === "Ok User"){          
          context.doLogin();
          sessionStorage.setItem("alumno", JSON.stringify(verifica.data.alumno));
          sessionStorage.setItem("carreras", JSON.stringify(verifica.data.carreras));
          sessionStorage.setItem("preinscripciones", JSON.stringify((verifica.data.preinscripciones)));
          inscripcionesService.ObtenerRematriculacionesAbiertas().then(periodos =>{
            sessionStorage.setItem("rematriculaciones", JSON.stringify(periodos.data));          
            window.location.reload(true);   
          }
          );

          history.push("/");          
        } else {
          sessionStorage.removeItem("token");
          toast.error("No se pudo iniciar sesión, el sistema de autogestión se encuentra habilitado exclusivamente para el acceso de alumnos de la institución", {autoClose: 10000});
        }        
      });                  
    }   
  }, [stLogin]);

  const onSubmitLogin = (e) => {
    e.preventDefault();
    const ingresoEmail = e.target.elements.ingresoEmail.value;
    const ingresoPassword = e.target.elements.ingresoPassword.value;
    const cookies = new Cookies();
    cookies.remove('sessionid', { path: '/' });
    usuariosService.Ingreso(ingresoEmail, ingresoPassword).then(login => {
    if (login === "OK"){   
      setStLogin(true);      
    } else {
      toast.error("No se pudo iniciar sesión, verifique que el correo electrónico y la contraseña sean correctos", {autoClose: 10000});
    }
    });
  };

  const onSubmitRestore = (e) => {
    e.preventDefault();
    const recuperarEmail = e.target.elements.recuperarEmail.value;
    usuariosService.RecuperarClave(recuperarEmail).then(resultado => {
      if (resultado === "OK"){   
        toast.success("Se ha enviado un mail a la cuenta " + recuperarEmail + " con una nueva contraseña de acceso", {autoClose: 10000});      
      } else {
        toast.error("No se pudo iniciar restablecer la contraseña, verifique que el correo electrónico corresponda con el que tiene registrado como alumno de la institución", {autoClose: 10000});
      }
      });    
    handleClose1();
  };

  const [open1, setOpen1] = React.useState(false);

  const handleClickOpen1 = () => {
    setOpen1(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };


  return (
    <Fragment>
      <ToastContainer />
      <div className="app-wrapper min-vh-100">
        <div className="app-main flex-column">
          <div className="app-content p-0">
            <div className="app-content--inner d-flex align-items-center">
              <div className="flex-grow-1 w-100 d-flex justify-content-center">
              <Container maxWidth="lg" className="d-flex justify-content-center">
                    <Grid container spacing={5} className="d-flex justify-content-center">
                      <Grid
                        item
                        xs={12}
                        lg={7}
                        className="d-flex flex-column align-items-center">                                                      
                        <Card className="m-0 w-100 p-0 border-0">
                        <div className="card-header pr-2">
                        <div className="text-center text-black-50 mb-3">
                               <img
                                  src={imgLogo}
                                  className="center"
                                  alt=""
                                />
                            </div>       
                            <div className="card-header--title py-2 font-size-lg font-weight-bold text-center">
                                INGRESO AL SISTEMA DE AUTOGESTIÓN
                            </div>
                            </div>                                                  
                          <CardContent className="p-3">
                            <form className="px-5" onSubmit={onSubmitLogin}>
                              <div className="mb-3">
                                <FormControl className="w-100">
                                  <InputLabel htmlFor="input-with-icon-adornment">
                                    Correo electrónico
                                  </InputLabel>
                                  <Input
                                    fullWidth
                                    id="ingresoEmail"
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <MailOutlineTwoToneIcon />
                                      </InputAdornment>
                                    }
                                    required
                                  />
                                </FormControl>
                              </div>
                              <div className="mb-3">
                                <FormControl className="w-100">
                                  <InputLabel htmlFor="standard-adornment-password">
                                    Contraseña
                                  </InputLabel>
                                  <Input
                                    id="ingresoPassword"
                                    fullWidth
                                    type="password"
                                    autoComplete="true"
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <LockTwoToneIcon />
                                      </InputAdornment>
                                    }
                                    required
                                  />
                                </FormControl>
                              </div>
                              <div className="w-100">
                                
                              </div>
                              <div className="text-center">
                                <Button
                                  color="primary"
                                  variant="contained"
                                  size="large"
                                  className="my-2"
                                  type="submit">
                                  Ingresar
                                </Button>
                              </div>
                            </form>
                            <div className="w-100">
                                   <Button
                                        className="m-2"        
                                        color="primary"
                                        onClick={handleClickOpen1}>
                                        He olvidado mi contraseña
                                      </Button>
                                      <Dialog
                                        open={open1}
                                        onClose={handleClose1}
                                        aria-labelledby="form-dialog-title">
                                         <form onSubmit={onSubmitRestore}>
                                        <DialogTitle id="form-dialog-title"><h3>Restablecimiento de contraseña</h3></DialogTitle>
                                        <DialogContent>
                                          <DialogContentText align="justify">
                                          Para restablecer la contraseña deberás ingresar la dirección de correo electrónico que tengas registrada. Luego de eso, recibirás un correo electrónico con las indicaciones para generar una nueva contraseña de acceso (revisa también la casilla de Correo no deseado/SPAM).
                                          </DialogContentText>
                                          <DialogContentText>
                                          Si tienes alguna consulta al respecto comunícate con tu Facultad.
                                          </DialogContentText>
                                          <DialogContentText align="justify">
                                          <strong>¿Deseas iniciar el proceso?</strong>
                                          </DialogContentText>
                                          <TextField
                                            autoFocus
                                            margin="dense"
                                            id="recuperarEmail"
                                            label="Correo electrónico"
                                            type="email"
                                            required
                                            fullWidth
                                          />
                                        </DialogContent>
                                        <DialogActions>
                                          <Button type='submit' variant="contained" className="m-2 btn text-success">
                                         SI, RESTABLECER
                                          </Button>
                                          <Button onClick={handleClose1} variant="contained" className="m-2 btn text-danger">
                                            NO, CANCELAR
                                          </Button>
                                        </DialogActions>
                                        </form>
                                      </Dialog>
                              </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Container>
              </div>             
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default LoginComponent;